import axios from "axios";

const actions = {
  /**
   * Fetch feature requests with pagination and sorting
   * @param {Object} payload - { page, size, sort }
   * @returns {Promise}
   */
  fetchFeatureRequests({ commit }, { page = 1, size = 10, sort = "votes" }) {
    commit("SET_LOADING", true);
    return axios
      .get("/feature_requests", {
        params: { page, size, sort },
      })
      .then((response) => {
        commit("SET_FEATURE_REQUESTS", response.data.data);
        commit("SET_PAGINATION", response.data.pagination);
        commit("SET_LOADING", false);
        return response.data;
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        throw error;
      });
  },

  /**
   * Create a new feature request
   * @param {Object} payload - { message }
   * @returns {Promise}
   */
  createFeatureRequest({ commit, dispatch, state }, { title, message }) {
    return axios
      .post("/feature_requests", { title, message })
      .then((response) => {
        // Refresh the current view after creating
        dispatch("fetchFeatureRequests", {
          page: state.currentPage,
          size: state.pageSize,
          sort: state.sortOrder,
        });
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  /**
   * Upvote a feature request
   * @param {Number} id - Feature request ID
   * @returns {Promise}
   */
  upvoteFeatureRequest({ commit }, id) {
    return axios
      .post(`/feature_requests/${id}/vote`)
      .then((response) => {
        // Update the vote count in the store
        commit("UPDATE_FEATURE_REQUEST", response.data);
        // Track that this request has been voted on
        commit("ADD_VOTED_REQUEST", id);
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  /**
   * Delete a feature request
   * @param {Number} id - Feature request ID
   * @returns {Promise}
   */
  deleteFeatureRequest({ commit, dispatch, state }, id) {
    return axios
      .delete(`/feature_requests/${id}`)
      .then(() => {
        // Refresh the current view after deletion
        dispatch("fetchFeatureRequests", {
          page: state.currentPage,
          size: state.pageSize,
          sort: state.sortOrder,
        });
      })
      .catch((error) => {
        throw error;
      });
  },

  /**
   * Set current page
   */
  setCurrentPage({ commit }, page) {
    commit("SET_CURRENT_PAGE", page);
  },

  /**
   * Set sort order
   */
  setSortOrder({ commit }, sort) {
    commit("SET_SORT_ORDER", sort);
  },
};

export default actions;
